import(/* webpackMode: "eager" */ "/vercel/path0/components/About.js")